/**
 * ⟦C62 · lot atelier · friction 7⟧ **La note de fin d'étape : « 14 / 100 », un mot, une conséquence.**
 *
 * Posée une fois, partagée par les cinq mini-jeux (leur écran de fin était un chiffre nu : « 14 »).
 * Le gros chiffre reste celui du joueur, entier, jamais raturé (⟦A-32⟧) ; l'échelle (« / 100 ») et le mot
 * (`noteEnMot`) lui donnent le sens qui lui manquait. `consequence` est la ligne que l'Atelier ajoute sur
 * ce que la chaîne en fait (« ⚠ Risque de vidéo nulle », « Bonus de viralité ! », « Plafonné à 85 ») :
 * absente d'un mini-jeu monté seul.
 */

import { noteEnMot } from "./note";

/**
 * Le mot seul (« Bien »), en pastille : pour une ligne de récap, ou le score d'une publication, là où le gros
 * chiffre n'a pas sa place. `petit` : la taille d'une ligne de liste.
 */
export function MotDeNote({ note, petit = false }: { note: number; petit?: boolean }) {
  const { mot, ton } = noteEnMot(note);
  return <span className={`note-mot note-mot--${ton}${petit ? " note-mot--petit" : ""}`}>{mot}</span>;
}

export function NoteSur100({
  note,
  consequence,
}: {
  note: number;
  /** Ce que la chaîne en fait, dit par l'Atelier (`ProprietesMiniJeu.consequence`). */
  consequence?: string | null;
}) {
  const n = Math.round(note);
  const { mot, ton } = noteEnMot(n);
  // Un bloc, pas trois frères : l'écran de fin de « La prise parfaite » le range à droite de son titre.
  return (
    <div className="note-bloc">
      <p className="score-gros note-gros" data-note={n}>
        {n}
        <span className="note-sur"> / 100</span>
      </p>
      <p className={`note-mot note-mot--${ton}`}>{mot}</p>
      {consequence ? <p className="jeu-seuils">{consequence}</p> : null}
    </div>
  );
}
